module.exports = __webpack_public_path__ + "assets/img/card-bg-default.172e6be0.png";